/**
 * WordPress dependencies.
 */
import {
	RichText,
	useBlockProps
} from '@wordpress/block-editor';
import classnames from 'classnames';

const Save = ({
	attributes
}) => {

	let headingWidthClass = "";

	if( attributes.advWidth?.value =='fullwidth') {
		headingWidthClass = 'alignfull';
	}

	const animationClass = attributes?.advAnimation?.className || '';

	let Classes = classnames(
		animationClass,
		headingWidthClass,
		attributes.headingimage && attributes.headinganimation ? 'vayu_blocks_heading_image_animation-heading' : null, // Conditional class
    	attributes.headingimage  ? 'vayu_blocks_heading_image-heading' : null, // Conditional class for image without animation
		{	
		[`wp-block-vayu-blocks-advance-heading ${attributes.uniqueId}`]: true,
		  'th-hide-desktop': attributes.advResponsive?.Desktop === true,
          'th-hide-tablet': attributes.advResponsive?.Tablet === true,
          'th-hide-mobile': attributes.advResponsive?.Mobile === true,
	  });

	const blockProps = useBlockProps.save({
		id: attributes.uniqueId,
		className:Classes
	});

	return (
		<RichText.Content
			tagName={ attributes.tag }
			value={ attributes.content }
			{ ...blockProps }
		/>
	);
};

export default Save;
